<div class="action-dock">
  <button class="dock-hero-btn" (click)="onHeroClick()">
    <span class="material-icons">{{ heroIcon }}</span>
    <span>{{ heroText }}</span>
  </button>
  @for (action of actions; track action.id) {
    <button
      class="dock-action-btn"
      [class.has-data]="action.hasData"
      [class.selected]="isSelected(action)"
      (click)="onActionClick(action)"
      [attr.aria-label]="action.label || action.id">
      <span class="material-icons">{{ action.icon }}</span>
    </button>
  }
</div>
